"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.configuratorReducer = void 0;
var _redux = require("redux");
var _groupsReducer = _interopRequireDefault(require("./groupsReducer"));
var _optionsReducer = _interopRequireDefault(require("./optionsReducer"));
var _choicesReducer = _interopRequireDefault(require("./choicesReducer"));
var _ajaxStatusReducer = _interopRequireDefault(require("./ajaxStatusReducer"));
var _messageReducer = _interopRequireDefault(require("./messageReducer"));
var _productInfoReducer = _interopRequireDefault(require("./productInfoReducer"));
var _priceReducer = _interopRequireDefault(require("./priceReducer"));
var _choiceGroupsReducer = _interopRequireDefault(require("./choiceGroupsReducer"));
var _estimatedArrivalTimeReducer = _interopRequireDefault(require("./estimatedArrivalTimeReducer"));
var _persistenceReducer = _interopRequireDefault(require("./persistenceReducer"));
var _selectedChoicesReducer = _interopRequireDefault(require("./selectedChoicesReducer"));
var configuratorReducer = exports.configuratorReducer = (0, _redux.combineReducers)({
  groups: _groupsReducer["default"],
  options: _optionsReducer["default"],
  choices: _choicesReducer["default"],
  ajaxStatus: _ajaxStatusReducer["default"],
  messages: _messageReducer["default"],
  productInfo: _productInfoReducer["default"],
  pricing: _priceReducer["default"],
  choiceGroups: _choiceGroupsReducer["default"],
  estimatedArrivalTime: _estimatedArrivalTimeReducer["default"],
  savedProductChoices: _persistenceReducer["default"],
  selectedChoices: _selectedChoicesReducer["default"]
});
var rootReducer = (0, _redux.combineReducers)({
  configurator: configuratorReducer
});
var _default = exports["default"] = rootReducer;
//# sourceMappingURL=index.js.map